export const initialSate = {
  useEditableImage: false,
  variableConfigurations: [],
  variables: {},
  search: '',
  typeFilter: '',
  categoryFilter: '',
  useSearch: false,
  useTypeFilter: false,
  useCategoryFilter: false,
  useCategories: false,
  showVariableIDString: false,
  translations: {
    resetButtonTooltip: 'Reset button',
    searchInputPlaceholder: 'Search',
    typeFilterPlaceholder: 'All types',
    categoryFilterPlaceholder: 'All categories',
    showVariableIDStringLabel: 'Show Variable String',
    emptyStateTitle: 'No Settings to Show',
    emptyStateLead:
      'Style settings can be defined in the template as variables to provide more flexible campaign formatting options.',
    emptyStateLinkButton: 'Learn more',
    emptyStateLinkUrl: 'http://documentation.emarsys.com/',
    defaultValue: {
      image: {
        mediaDB: 'Media DB',
      },
    },
    validationErrors: {
      wrongIdFormat: 'This variable name is invalid. Please use only Latin letters (A-Z, a-z).',
      idAlreadyUsed: 'This variable name is already in use. Please try a new one.',
      wrongValue: 'This variable value is invalid. Please do not use curly brackets ({, }).',
      wrongImage: 'The image URL cannot be found.',
    },
    applyButton: 'Apply',
    cancelButton: 'Cancel',
    types: {
      color: 'Color',
      image: 'Image',
      integer: 'Integer',
      decimal: 'Decimal',
      string: 'String',
      select: 'Select',
    },
    categories: {
      account: 'Account',
      background: 'Background',
      backgroundImage: 'Background Image',
      bodyCopy: 'Body Copy',
      buttonCta: 'Call To Action',
      content: 'Content',
      darkMode: 'Dark Mode',
      dialog: 'Dialog',
      headline: 'Headline',
      image: 'Image',
      logo: 'Logo',
      navigationMenu: 'Navigation Menu',
      paddingSpacing: 'Padding/Spacing',
      price: 'Price',
      ribbon: 'Ribbon',
      uncategorized: 'Uncategorized',
    },
  },
};
